export class LocationSearch {
    CustomerId: string;
    ScrollIndex: number;
    PageSize: number;
    SearchString: string;
    City: string;
    State: string;
    Country: string;
    IsTypeAhead: boolean;
}